import React, { FC, useState } from 'react';
import './index.css';
import AddFoodComponent from '../TrackerWidget';
import NutritionDashboard from '../TrackerStats';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { postMeal } from '../../services/postMeal';

const Tracker: FC = () => {
  const [mutationProcess, setMutationProcess] = useState(false);
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: postMeal,
    onMutate: () => {
      setMutationProcess(true);
    },
    onSuccess: async () => {
      setMutationProcess(false);
      // Invalidate both track and stats queries
      await queryClient.invalidateQueries({ queryKey: ['track'] });
      await queryClient.invalidateQueries({ queryKey: ['stats'] });
    },
    onError: () => {
      setMutationProcess(false);
    },
  });

  return (
    <div>
      <AddFoodComponent mutation={mutation} />
      <NutritionDashboard mutationProcess={mutationProcess} />
    </div>
  );
};

export default Tracker;
